import axios from "axios";
import { VERIFY_EMAIL_URL } from "../urls";

export const postVerifyEmail = async (token) => {
  try {
    return axios.post(`${VERIFY_EMAIL_URL}${token}`, {}, {});
  } catch (error) {
    throw error;
  }
}